import moment from "moment";

function isAtrasado(prazoEmMinutos, createdAt) {
  if (prazoEmMinutos === 0) return false;

  return moment().isAfter(moment(createdAt).add(prazoEmMinutos, 'minutes'));
}

export default isAtrasado;